/* globals gtag, fbq, $ */

'use strict';

const { setCookie, hasCookie } = require('../../lib/cookie');

$(function () {
  $('.fund-rating-item .top').click(function () {
    $(this).parent().find('.expandable').toggleClass('expanded');
    $(this).find('.icon-down-arrow').toggleClass('flip');
  });

  function expandDesktopContainer(expanded) {
    if ($('#fund-desktop-content-container').hasClass('expanded')) {
      if (!expanded) {
        $('#fund-desktop-content-container').removeClass('expanded');
      }
    } else {
      $('#fund-desktop-content-container').addClass('expanded');
    }
  }

  $('#desktop-cost-controller-item').click(function () {
    if (!$('#desktop-cost-container').hasClass('show')) {
      expandDesktopContainer(true);
      $('#desktop-cost-container').addClass('show');
      $('#desktop-triangle').css('left', '17%');
    } else {
      expandDesktopContainer(false);
    }

    if ($('#desktop-result-container').hasClass('show')) {
      $('#desktop-result-container').removeClass('show');
    }

    if ($('#desktop-requirements-container').hasClass('show')) {
      $('#desktop-requirements-container').removeClass('show');
    }
  });

  $('#desktop-result-controller-item').click(function () {
    if ($('#desktop-cost-container').hasClass('show')) {
      $('#desktop-cost-container').removeClass('show');
    }

    if (!$('#desktop-result-container').hasClass('show')) {
      $('#desktop-result-container').addClass('show');
      expandDesktopContainer(true);
      $('#desktop-triangle').css('left', '50%');
    } else {
      expandDesktopContainer(false);
    }

    if ($('#desktop-requirements-container').hasClass('show')) {
      $('#desktop-requirements-container').removeClass('show');
    }
  });

  $('#desktop-requirements-controller-item').click(function () {
    if ($('#desktop-cost-container').hasClass('show')) {
      $('#desktop-cost-container').removeClass('show');
    }

    if ($('#desktop-result-container').hasClass('show')) {
      $('#desktop-result-container').removeClass('show');
    }

    if (!$('#desktop-requirements-container').hasClass('show')) {
      $('#desktop-requirements-container').addClass('show');
      expandDesktopContainer(true);
      $('#desktop-triangle').css('left', '83%');
    } else {
      expandDesktopContainer(false);
    }
  });

  $('.year-1').click(function () {
    $('.benchmark-1yr').css('opacity', 1);
    $('.benchmark-3yr').css('opacity', 0);
    $('.benchmark-5yr').css('opacity', 0);
    $('.year-1 span').addClass('selected');
    $('.year-3 span').removeClass('selected');
    $('.year-5 span').removeClass('selected');
  });

  $('.year-3').click(function () {
    $('.benchmark-1yr').css('opacity', 0);
    $('.benchmark-3yr').css('opacity', 1);
    $('.benchmark-5yr').css('opacity', 0);
    $('.year-1 span').removeClass('selected');
    $('.year-3 span').addClass('selected');
    $('.year-5 span').removeClass('selected');
  });

  $('.year-5').click(function () {
    $('.benchmark-1yr').css('opacity', 0);
    $('.benchmark-3yr').css('opacity', 0);
    $('.benchmark-5yr').css('opacity', 1);
    $('.year-1 span').removeClass('selected');
    $('.year-3 span').removeClass('selected');
    $('.year-5 span').addClass('selected');
  });

  $('#download-button').click(function () {
    /* eslint-disable camelcase */
    gtag('event', 'download_clicked', {
      event_category: 'reading',
      event_label: 'Fund Page',
    });
    /* eslint-enable camelcase */
    fbq('track', 'DownloadClicked');
  });

  const riskInformation = $('.fund-risk-information');
  const riskInformationHiddenCookie = 'fund-risk-information-hidden';
  const hasRiskInformationHiddenCookie = hasCookie(riskInformationHiddenCookie);
  riskInformation.find('.close-button').click(() => {
    riskInformation.hide();

    // 'cookieDomain' is defined in 'base.hbs'
    let domain = cookieDomain; // eslint-disable-line no-undef

    let expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 1);

    setCookie(riskInformationHiddenCookie, 'true', expiryDate, '/', domain);
  });

  if (hasRiskInformationHiddenCookie === false) {
    riskInformation.show();
  }
});
